import { authenticatedUserActions } from './reducers';

export const {
  getAuthenticatedUserAction,
  setAuthenticatedUserAction,
  setAuthenticatedUserErrorAction,
  clearAuthenticatedUserAction,
  clearAuthenticatedUserDoneAction,
  setAuthenticatedUserNeedsMfaAction,
  clearAuthenticatedUserNeedsMfaAction,
} = authenticatedUserActions;
